import React from 'react';
import CxDate from '../../cx/CxDate';
import CxButton from '../../cx/CxButton';
import CxInput from '../../cx/CxInput';
import * as FxFetch from '../../fx/FxFetch';
import * as FxLog from '../../fx/FxLog';

const messages = {
  formTitle: { es: 'Solicitud de Cita Online', en: 'Online Appointment Request' },
  apptDate: { es: 'Fecha para tu cita', en: 'Appointment date' },
  selectTime: { es: 'Seleccione horario', en: 'Select time' },
  view: { es: 'Ver', en: 'View' },
  sending: { es: 'Enviando solicitud...', en: 'Sending request...' },
  success: { es: 'Cita solicitada correctamente', en: 'Appointment successfully requested' },
  sendError: { es: 'Error al solicitar la cita', en: 'Error while requesting appointment' },
  unexpectedError: { es: 'Error inesperado', en: 'Unexpected error' },
  loading: { es: 'Cargando horarios...', en: 'Loading available times...' },
  txTypeCalendarGrp: { es: 'Principal', en: 'Main' },
  onlineAppt: { es: 'Cita Online', en: 'Online Appointment' },
  reason: { es: 'Motivo', en: 'Reason' },
  noSlots: { es: 'No hay horarios disponibles en este centro.', en: 'There are no available time slots at this center.' },
};

const getQueryParam = (key) => {
  try {
    const query = new URLSearchParams(window.location.search);
    return query.get(key) || '';
  } catch (e) {
    return '';
  }
};

const MxClientOla = () => {
  const formWidth = 'var(--ibs_control_width_lg)';
  const rf_date = React.useRef(null);
  const rf_reason = React.useRef(null);

  const initialLang = getQueryParam('lang') === 'en' ? 'en' : 'es';
  const initialApp = getQueryParam('app') || '';
  const initialIdi = getQueryParam('idi') || '';
  const initialCy = getQueryParam('cy') || '';
  const initialInClient = getQueryParam('inClient') || '';
  const initialInAnimal = getQueryParam('inAnimal') || '';

  const [lang] = React.useState(initialLang);
  const [app] = React.useState(initialApp);
  const [idi] = React.useState(initialIdi);
  const [cy] = React.useState(initialCy);
  const [inClient] = React.useState(initialInClient);
  const [inAnimal] = React.useState(initialInAnimal);

  const [apptDate, setApptDate] = React.useState('');
  const [slots, setSlots] = React.useState([]);
  const [loadingSlots, setLoadingSlots] = React.useState(false);
  const [showViewButton, setShowViewButton] = React.useState(false);
  const [sending, setSending] = React.useState(false);
  const [sentOk, setSentOk] = React.useState(false);
  const [showNoSlots, setShowNoSlots] = React.useState(false);

  const [sendStatus, setSendStatus] = React.useState({
    type: '',
    message: '',
  });

  const getMessage = (key) => messages[key]?.[lang] || '';

  const loadSlots = () => {
    if (!apptDate) return;

    try {
      setLoadingSlots(true);
      setSlots([]);
      setShowNoSlots(false);

      FxFetch.doJsonX('cal/online/load_slots', {
        txIdi: idi,
        dtAppt: apptDate,
        app: app,
      })
        .then((res) => {
          if (Array.isArray(res) && res.length > 0) {
            setSlots(res);
          } else {
            setSlots([]);
            setShowNoSlots(true);
            setTimeout(() => setShowNoSlots(false), 4000);
          }
        })
        .catch((err) => {
          FxLog.errorx('MxClientOla.loadSlots', err);
        })
        .finally(() => {
          setLoadingSlots(false);
        });
    } catch (error) {
      FxLog.errorx('MxClientOla.loadSlots.try', error);
      setLoadingSlots(false);
    }
  };

  const sendSlot = (itCalendarCol, tmFrom, tmTo, txTypeCalendarGrp) => {
    try {
      if (!inClient) {
        // si no hay cliente viene de afuera (ie: página web del cliente).
        // Redirigimos a nci para crear cliente y luego enviar cita.
        const baseUrl = window.location.origin;
        let url = '';
        let appt = `${apptDate}|${tmFrom}|${tmTo}|${itCalendarCol}|${txTypeCalendarGrp}|${encodeURIComponent(rf_reason.current.getVal())}`;
        if (inAnimal) {
          url = `${baseUrl}/nci?lang=${lang}&app=${app}&idi=${idi}&cy=${cy}&inClient=${inClient}&inAnimal=${inAnimal}&appt=${appt}`;
        } else {
          url = `${baseUrl}/nci?lang=${lang}&app=${app}&idi=${idi}&cy=${cy}&inClient=${inClient}&appt=${appt}`;
        }
        FxLog.infox('MxClientOla.sendSlot', '...url:', url);
        window.location.href = url;
        return;
      }

      // hay cliente, o sea que viene del portal del cliente y se puede registrar la cita a ese cliente.
      let record = {};
      record['txApp'] = app;
      record['txIdi'] = idi;
      record['n_calendar.itCalendarCol'] = itCalendarCol;
      record['n_calendar.inClient'] = inClient;
      if (inAnimal) record['n_calendar.inAnimal'] = inAnimal;
      record['n_calendar.dtFrom'] = `${apptDate} ${tmFrom}:00`;
      record['n_calendar.dtTo'] = `${apptDate} ${tmTo}:00`;
      record['t_calendar_grp.txTypeCalendarGrp'] = txTypeCalendarGrp;
      record['n_calendar.txRemarks'] = (!rf_reason.current.isEmpty() ? rf_reason.current.getVal() : getMessage('onlineAppt'));
      record['n_calendar.txNotes'] = '';

      setSending(true);
      setSendStatus({ type: '', message: '' });

      FxFetch.doJsonX('cal/online/cu', record)
        .then((result) => {
          if (result?.theStatus === 'OK') {
            setSentOk(true);
            setSendStatus({
              type: 'success',
              message: getMessage('success'),
            });
          } else {
            setSendStatus({
              type: 'error',
              message: getMessage('sendError'),
            });
          }
        })
        .catch((err) => {
          FxLog.errorx('MxClientOla.sendSlot.catch', err);
          setSendStatus({
            type: 'error',
            message: getMessage('unexpectedError'),
          });
        })
        .finally(() => {
          setSending(false);
        });

    } catch (error) {
      FxLog.errorx('MxClientOla.sendSlot', error);
      setSending(false);
    }
  };

  // ✅ AGRUPACIÓN CORRECTA POR txTypeCalendarCol
  const groupedSlots = React.useMemo(() => {
    const groups = {};
    slots.forEach((slot) => {
      const colType = slot.txTypeCalendarCol || 'General';
      if (!groups[colType]) groups[colType] = [];
      groups[colType].push(slot);
    });
    return groups;
  }, [slots]);

  if (sentOk) {
    return (
      <div style={{ width: formWidth, margin: 'auto', textAlign: 'center' }}>
        <h3>{getMessage('formTitle')}</h3>
        <div style={{ color: 'var(--ibs_color_green)', fontSize: '14px' }}>
          {sendStatus.message}
        </div>
      </div>
    );
  }

  if (sending) {
    return (
      <div style={{ width: formWidth, margin: 'auto', textAlign: 'center' }}>
        <h3>{getMessage('sending')}</h3>
      </div>
    );
  }

  return (
    <div style={{ width: formWidth, margin: 'auto', display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <h3 style={{ textAlign: 'center' }}>
        {cy ? cy.toUpperCase() : ''}
      </h3>

      <CxDate
        xref={rf_date}
        label={getMessage('apptDate')}
        value={apptDate}
        onChangeDate={(isoValue) => {
          setShowViewButton(!!isoValue);
          setApptDate(isoValue);
          setSlots([]);
          setShowNoSlots(false);
        }}
      />

      <CxInput 
        xref={rf_reason} 
        label={getMessage('reason')} 
      />

      {showViewButton && (
        <CxButton label={getMessage('view')} width="100%" onClick={loadSlots} />
      )}

      {Object.keys(groupedSlots).length > 0 && (
        <div style={{ fontSize: '18px', textAlign: 'center', opacity: 0.7, marginTop: '6px' }}>
          {getMessage('selectTime')}
        </div>
      )}

      {loadingSlots && (
        <div style={{ fontSize: '12px', textAlign: 'center', opacity: 0.7 }}>
          {getMessage('loading')}
        </div>
      )}

      {showNoSlots && (
        <div style={{ fontSize: '13px', textAlign: 'center', color: 'var(--ibs_color_red)' }}>
          {getMessage('noSlots')}
        </div>
      )}

      {Object.entries(groupedSlots).map(([colType, colSlots]) => (
        <div key={colType}>
          <div style={{ fontWeight: 'bold', marginTop: '10px' }}>
            {colType}
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '6px' }}>
            {colSlots.map((slot) => (
              <div
                key={`${slot.dtDay}|${slot.tmFrom}|${slot.tmTo}|${colType}`}
                onClick={() => sendSlot(slot.itCalendarCol, slot.tmFrom, slot.tmTo, slot.txTypeCalendarGrp)}
                style={{
                  padding: '8px',
                  border: '1px solid var(--ibs_color_gray_light)',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  textAlign: 'center',
                  fontSize: '13px',
                  width: '80px',
                }}
              >
                {slot.tmFrom} - {slot.tmTo}
              </div>
            ))}
          </div>
        </div>
      ))}

      <span style={{ marginTop: '10px' }} />

      {sendStatus.type === 'error' && (
        <div style={{ color: 'var(--ibs_color_red)', fontSize: '13px' }}>
          {sendStatus.message}
        </div>
      )}
    </div>
  );
};

export default MxClientOla;
